<template>
    <div id="navbox">
        <div class="slotContainer">
            <slot @click="$emit('click')"></slot>
        </div>
        <slot name="noStyling"></slot>
    </div>
</template>

<script>
    export default {
        name: "Navbox"
    }
</script>

<style lang="scss" scoped>
    #navbox {
        min-width: 220px;
        height: auto;
        background: white;
        display: flex;
        flex-flow: column;
        padding: 20px;
        justify-content: center;
        font-size: 15px;
    }

    .navboxItem:before {
        border-style: solid;
        border-width: 0.05em 0.05em 0 0;
        content: '';
        display: inline-block;
        height: 0.35em;
        left: 0.15em;
        position: relative;
        top: 0.6em;
        transform: rotate(45deg);
        vertical-align: top;
        width: 0.35em;
        margin-right: 10px;
    }

    .navboxItem {
        margin-bottom: 5px;
        text-decoration: underline;
        cursor: pointer;
    }

    .slotContainer > *:before{
        border-style: solid;
        border-width: 0.05em 0.05em 0 0;
        content: '';
        display: inline-flex;
        height: 0.35em;
        left: 0.15em;
        position: relative;
        top: 0.45em;
        transform: rotate(45deg);
        vertical-align: top;
        width: 0.35em;
        margin-right: 10px;
    }

    .slotContainer > *{
        margin-bottom: 5px;
        text-decoration: underline;
        cursor: pointer;
        display: block;
    }

    button{
        margin-bottom: .5rem;
        width: 100%;
    }
</style>